import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Animations } from 'src/app/animations';
import { HorizontalGraphView, HorizontalItemRow } from 'src/app/model/horizontal-graph';

@Component({
  selector: 'app-horizontal-bar-graph',
  templateUrl: './horizontal-bar-graph.component.html',
  styleUrls: ['./horizontal-bar-graph.component.scss'],
  animations: [
    Animations.fadeInOut
  ]
})
export class HorizontalBarGraphComponent {
  @Input() selectedItem: String = '';
  @Input() withGestures: boolean = true;
  @Input() graph: HorizontalGraphView = {} as HorizontalGraphView;
  @Output() onSelectItem: EventEmitter<String> = new EventEmitter<String>(true);

  public maxValue: number = 1;

  constructor() { }

  ngOnInit(): void {
    this.setMaxValue();
    this.setDefaultSelectedItem();
  }

  private setDefaultSelectedItem(): void {
    const index = this.graph.data.findIndex(item => item.title === this.selectedItem);

    if(!this.selectedItem || index === -1) {
      this.onSelectItem.emit(this.graph.data[0].title);
    }
  }

  private setMaxValue(): void {
    this.maxValue = this.graph.data.reduce((acc: number, item: HorizontalItemRow) => {
      if(item.value.value > acc) {
        return item.value.value;
      }
      else {
        return acc;
      }
    }, 0);
  }

  public barClick(title: String): void {
    this.selectedItem = title;
    this.onSelectItem.emit(this.selectedItem);
  }

  public trackByFn(index: number, item: any): number {
    return index;
  }
}
